// @ts-nocheck
/* eslint-disable func-names */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/named */
import { takeLatest, takeEvery, spawn, put } from 'redux-saga/effects';

import apiRequest, { apiSuccess } from 'utils/api';
import { truthty, falsy } from 'utils/functions';
import { appActions } from 'commons/reducer';
import { PROVIDERS } from '../reducer';

function* getStateFromApi() {
  yield takeLatest(PROVIDERS.GET_STATE_FROM_API, function* (action) {
    const response = yield apiRequest('api/v1/suppliers', { method: 'get' });
    yield put(apiSuccess(PROVIDERS.GET_STATE_FROM_API_SUCCESS, response));
  });
}

function* createSupplier() {
  yield takeLatest(PROVIDERS.CREATE_PROVIDER, function* (action) {
    yield put(appActions.setLoader('create-edit-supplier', true));
    const controls = { ...action.controls };
    if (truthty(controls.phone) && !controls.phone.startsWith('+')) {
      controls.phone = `+56${controls.phone}`;
    }
    const response = yield apiRequest('api/v1/suppliers', {
      method: 'post',
      body: JSON.stringify(controls),
    });
    if (!response.ok || truthty(response.error)) {
      const errorMsg = response.errorMsg || response.message || response.error;
      const finalError = errorMsg === 'Error in request' ? 'Supplier creation error' : errorMsg;
      yield put(appActions.setError(finalError));
    } else {
      yield put(apiSuccess(PROVIDERS.CREATE_PROVIDER_SUCCESS, response));
      yield put(appActions.setSuccess('Supplier created successfully'));
    }
    yield put(appActions.setLoader('create-edit-supplier', false));
  });
}

function* editSupplier() {
  yield takeLatest(PROVIDERS.EDIT_PROVIDER, function* (action) {
    yield put(appActions.setLoader('create-edit-supplier', true));
    const controls = { ...action.controls };
    if (truthty(controls.phone) && !controls.phone.startsWith('+')) {
      controls.phone = `+56${controls.phone}`;
    }
    const response = yield apiRequest(`api/v1/suppliers/${action.id}`, {
      method: 'put',
      body: JSON.stringify(controls),
    });
    if (!response.ok || truthty(response.error)) {
      const errorMsg = response.errorMsg || response.message || response.error;
      const finalError = errorMsg === 'Error in request' ? 'Supplier update error' : errorMsg;
      yield put(appActions.setError(finalError));
    } else {
      yield put(apiSuccess(PROVIDERS.EDIT_PROVIDER_SUCCESS, response));
      yield put(appActions.setSuccess('Supplier updated successfully'));
    }
    yield put(appActions.setLoader('create-edit-supplier', false));
  });
}

function* deleteSupplier() {
  yield takeLatest(PROVIDERS.DELETE_PROVIDER, function* (action) {
    yield put(appActions.setLoader('delete-supplier', true));
    const response = yield apiRequest(`api/v1/suppliers/${action.id}`, { method: 'delete' });
    if (response.ok && falsy(response.error)) {
      const item = Object.values(response)[0];
      yield put(apiSuccess(PROVIDERS.DELETE_PROVIDER_SUCCESS, { item, type: 'suppliers' }));
    } else {
      yield put(appActions.setError(response.errorMsg || response.message || response.error));
    }
    yield put(appActions.setLoader('delete-supplier', false));
  });
}

function* exportSuppliers() {
  yield takeLatest(PROVIDERS.EXPORT_PROVIDER, function* (action) {
    yield put(appActions.setLoader('export-suppliers', true));
    const response = yield apiRequest(
      'api/v1/suppliers/export',
      { method: 'get' },
      false,
      'suppliers.xlsx',
    );
    yield put(apiSuccess(PROVIDERS.EXPORT_PROVIDER_SUCCESS, response));
    yield put(appActions.setLoader('export-suppliers', false));
  });
}

function* importSuppliers() {
  yield takeLatest(PROVIDERS.IMPORT_PROVIDERS, function* (action) {
    yield put(appActions.setLoader('import-suppliers', true));
    yield put(
      appActions.showImportModal({
        title: 'Importando Proveedores',
      }),
    );
    try {
      const tenant = window.location.hostname.split('.')[0];
      const formData = new FormData();
      formData.append('file', action.payload.file);
      formData.append('type', action.payload.type);
      formData.append('socketId', action.payload.socketId);
      formData.append('tenant', tenant);

      const response = yield apiRequest('api/v1/suppliers/import', {
        method: 'post',
        body: formData,
      });

      if (truthty(response.error)) {
        yield put({ type: PROVIDERS.IMPORT_PROVIDERS_ERROR, payload: response.errorMsg });
        yield put(appActions.setError(response.errorMsg));
      } else {
        yield put({ type: PROVIDERS.IMPORT_PROVIDERS_SUCCESS, payload: response });
      }
    } catch (error) {
      yield put({
        type: PROVIDERS.IMPORT_PROVIDERS_ERROR,
        payload: 'Error al iniciar importación ',
      });
    }
  });
}

function* handleImportSocketResponse() {
  yield takeEvery(
    [PROVIDERS.IMPORT_PROVIDERS_SOCKET_SUCCESS, PROVIDERS.IMPORT_PROVIDERS_SOCKET_ERROR],
    function* (action) {
      yield put(appActions.setLoader('import-suppliers', false));

      if (action.type === PROVIDERS.IMPORT_PROVIDERS_SOCKET_SUCCESS) {
        yield put({ type: PROVIDERS.GET_STATE_FROM_API });

        const result = action.payload.importResult;
        const processedCount = result?.processed || 'varios';
        yield put(appActions.setSuccess(`${processedCount} proveedores procesados exitosamente`));
      } else if (action.type === PROVIDERS.IMPORT_PROVIDERS_SOCKET_ERROR) {
        const errorMsg = action.payload.error || 'Error desconocido en la importación';
        yield put(appActions.setError(`${errorMsg}`));
      }
    },
  );
}

export default function* saga() {
  yield spawn(getStateFromApi);
  yield spawn(deleteSupplier);
  yield spawn(createSupplier);
  yield spawn(editSupplier);
  yield spawn(exportSuppliers);
  yield spawn(importSuppliers);
  yield spawn(handleImportSocketResponse);
}
